import './dons-etablissements.scss';

(($) => {
    function initTabs() {
        $('.section-dons-etablissements .tabs .tab').click(function() {
            var tabId = $(this).data('tab');

            $(this).parent().find('.tab.active').removeClass('active');
            $(this).addClass('active');

            $(this).parent().parent().find('.content-tab > div').hide();
            $(this).parent().parent().find('.content-tab > div[data-tab="' + tabId + '"]').show();
        });

        // Activer le premier onglet par défaut
        $('.section-dons-etablissements .tabs .tab:first-child').addClass('active');
        $('.section-dons-etablissements .content-tab > div:first-child').show();
    }
    if ($("body").hasClass("wp-admin")) {
        $(document).on("initTabs", initTabs);
    } else {
        $(document).ready(initTabs);
    }
})(jQuery);